import Fly from "flyio/dist/npm/fly";
import { showDanger, showWarning } from "../utils/index";
import cookie from "cookie";

const API_ENV = process.env.API_ENV; // dev or production

const fly = new Fly();
// 设置超时
fly.config.timeout = 30000;

// 获取当前语言设置
const getCurrentLocale = () => {
    try {
        // 从 Redux store 中获取语言设置
        const state = window.reduxStore?.getState();
        if (state && state.locales) {
            return state.locales.locale;
        }
        // 如果无法从 store 获取，尝试从 cookie 读取
        const savedLocale = cookie.parse(document.cookie)["language"];
        if (savedLocale) {
            return savedLocale === "zh" ? "zh-cn" : "en";
        }
        // 默认返回英文
        return "en";
    } catch (error) {
        console.error("[DEBUG] Failed to get locale:", error);
        return "en";
    }
};

// 将语言码转换为 Accept-Language 格式
const getAcceptLanguage = (locale) => {
    if (!locale) return "en-US";
    
    const lang = locale.toLowerCase();
    if (lang.startsWith("zh") || lang === "zh-cn") {
        return "zh-CN";
    }
    return "en-US";
};

/**
 * Request服务封装
 */
export default {
    sendRequest,
    reAjaxFun,
    clearRequestTime,
};

function sendRequest() {
    return {
        _sucCallback: null,
        _failCallback: null,
        _networkFailCallback: null,
        _method: "GET",
        _data: {},
        _header: { "content-type": "application/json; charset=utf-8" },
        _url: "",
        _responseType: undefined, // 新增响应类型字段
        send() {
            const token = cookie.parse(document.cookie)["xiaozhi_token"];
            if (token) {
                this._header.Authorization = "Bearer " + token;
            }

            // 添加 Accept-Language header
            const currentLocale = getCurrentLocale();
            this._header["Accept-Language"] = getAcceptLanguage(currentLocale);

            // 打印请求信息
            fly.request(this._url, this._data, {
                method: this._method,
                headers: this._header,
                responseType: this._responseType,
            })
                .then((res) => {
                    const error = httpHandlerError(
                        res,
                        () => {},
                        () => {}
                    );
                    if (error) {
                        return;
                    }
                    if (this._sucCallback) {
                        this._sucCallback(res);
                    }
                })
                .catch((res) => {
                    // 打印失败响应
                    httpHandlerError(
                        res,
                        this._failCallback,
                        this._networkFailCallback
                    );
                });
            return this;
        },
        success(callback) {
            this._sucCallback = callback;
            return this;
        },
        fail(callback) {
            this._failCallback = callback;
            return this;
        },
        networkFail(callback) {
            this._networkFailCallback = callback;
            return this;
        },
        url(url) {
            if (url) {
                url = url.replaceAll("$", "/");
            }
            this._url = url;
            return this;
        },
        data(data) {
            this._data = data;
            return this;
        },
        method(method) {
            this._method = method;
            return this;
        },
        header(header) {
            this._header = header;
            return this;
        },
        showLoading(showLoading) {
            this._showLoading = showLoading;
            return this;
        },
        async(flag) {
            this.async = flag;
        },
        // 新增类型设置方法
        type(responseType) {
            this._responseType = responseType;
            return this;
        },
    };
}

/**
 * Info 请求完成后返回信息
 * failCallback 回调函数
 * networkFailCallback 回调函数
 */
// 在错误处理函数中添加日志
function httpHandlerError(info, failCallback, networkFailCallback) {
    /** 请求成功，退出该函数 可以根据项目需求来判断是否请求成功。这里判断的是status为200的时候是成功 */
    let networkError = false;
    if (info.status === 200) {
        if (
            info.data.code === "success" ||
            info.data.code === 0 ||
            info.data.code === undefined
        ) {
            return networkError;
        } else if (info.data.code === 401 || info.data.code === 50008 || info.data.code === 50012 || info.data.code === 50014) {
            // token 过期或认证失败，清除 token 并跳转
            document.cookie = "course_ok_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
            document.cookie = "course_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
            document.cookie = "xiaozhi_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";

            // 根据环境判断跳转地址
            if (API_ENV === "dev") {
                // 开发环境：跳转到本项目的登录页
                window.location.href = "/login";
            } else {
                // 生产环境：跳转到 edu.olou.cn 进行登录
                window.location.href = "https://edu.olou.cn/course/#/";
            }
            return true;
        } else {
            if (failCallback) {
                failCallback(info);
            } else {
                showDanger(info.data.msg);
            }
            return true;
        }
    }
    if (networkFailCallback) {
        networkFailCallback(info);
    } else {
        showDanger(`网络请求出现了错误【${info.status}】`);
    }
    return true;
}

let requestTime = 0;
let reAjaxSec = 2;

function reAjaxFun(fn) {
    let nowTimeSec = new Date().getTime() / 1000;
    if (requestTime === 0) {
        requestTime = nowTimeSec;
    }
    let ajaxIndex = parseInt((nowTimeSec - requestTime) / reAjaxSec);
    if (ajaxIndex > 10) {
        showWarning("似乎无法连接服务器");
    } else {
        showWarning("正在连接服务器(" + ajaxIndex + ")");
    }
    if (ajaxIndex < 10 && fn) {
        setTimeout(() => {
            fn();
        }, reAjaxSec * 1000);
    }
}

function clearRequestTime() {
    requestTime = 0;
}
